import React from "react";
import IconComponent from "../Icons/IconComponent";
const Switch = ({ primary, position, onChange }) => {
    return <div className="switchButtonpaginationcontainer">
        <button
            className="button-secondary-icon switchButtonPaginationcontent"
            style={{
                borderRadius: "10px 0px 0px 10px",
                background: position === 0 ? "var(--primary-light)" : "var(--white)"
            }}
            onClick={() => onChange(0)}
        >
            <IconComponent dimensions="20" nameIcon="layoutList" color={position === 0 ? "primary-base" : primary ? "primary-base" : "carbone"} />
        </button>
        <button
            className="button-secondary-icon switchButtonPaginationcontent"
            style={{
                borderRadius: "0px 10px 10px 0px",
                background: position === 1 ? "var(--primary-light)" : "var(--white)"
            }}
            onClick={() => onChange(1)}
        >
            <IconComponent dimensions="20" nameIcon="layoutGrid" color={position === 1 ? "primary-base" : primary ? "primary-base" : "carbone"} />
        </button>
    </div>;
};
export default Switch;
